if (!window.__backToTopBound) {
  window.__backToTopBound = true;

  document.addEventListener('DOMContentLoaded', function () {
    var button = document.getElementById('BackToTop');
    if (!button) return;

    function toggleVisibility() {
      if (window.scrollY > 400) {
        button.classList.add('is-visible');
      } else {
        button.classList.remove('is-visible');
      }
    }

    toggleVisibility();
    window.addEventListener('scroll', toggleVisibility, { passive: true });

    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
}
